import { Component, Inject, Input, OnInit, forwardRef } from '@angular/core';
import { NgbActiveModal }  from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { MessagesService }      from '../messages/messages.service';
import { VendorFactoryService } from './vendor-factory.service';

@Component({
  selector: 'wor-vendor-resolve-matches',
  template: `
    <div class="modal-header state clearfix bg-info title">
      <h1>Vendor Matches</h1>
    </div>
    <div class="modal-body clearfix">
      <wor-table
        [(data)]="matches"
        [settings]="tableSettings"
        (rowClick)="onRowClick($event)">
      </wor-table>
    </div>
    <div class="modal-footer d-flex">
      <button type="button" class="btn btn-danger m-left-auto"
        (click)="modal.dismiss()">
        None Of These Match
      </button>
      <button type="button" class="btn btn-success"
        [disabled]="!selectedItems.length"
        (click)="confirm()">
        Confirm
      </button>
    </div>
  `
})
export class VendorResolveMatchesComponent implements OnInit {
  @Input() matches: any[] = [];

  selectedItems: any[] = [];
  tableSettings: any;

  constructor (
    public  modal               : NgbActiveModal,
    private messagesService     : MessagesService,
    private translateService    : TranslateService,
    @Inject(forwardRef(() => VendorFactoryService)) private vendorFactoryService: VendorFactoryService
  ) {}

  ngOnInit (): void {
    this.tableSettings = {
      columns: [
        {
          classes: 'text-left',
          field  : 'display_name',
          header : {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.NAME')
          }
        },
        {
          classes: 'text-left',
          field  : 'phone',
          header : {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.PHONE')
          },
          pipe: 'phone'
        },
        {
          classes: 'text-left',
          field  : 'mobile',
          header : {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.MOBILE')
          },
          pipe: 'mobilePhone'
        },
        {
          classes: 'text-left',
          field  : 'email',
          header : {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.EMAIL')
          }
        },
        {
          classes: 'text-left',
          field  : 'address1',
          header : {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.ADDRESS')
          }
        },
        {
          classes: 'text-left',
          field  : 'address2',
          header : {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.ADDRESS')
          }
        },
        {
          classes: 'text-left',
          field  : 'suburb',
          header : {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.SUBURB')
          }
        },
        {
          classes: 'text-left',
          field  : 'state',
          header : {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.STATE')
          }
        },
        {
          classes: 'text-left',
          field  : 'postcode',
          header : {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.POSTCODE')
          }
        }
      ],
      empty: {
        text: this.translateService.instant('GENERAL_SPACE.STATUS.NO_RESULTS')
      },
      pagination: {
        enabled: false
      },
      rows: {
        highlight: {
          enabled: true
        },
        select: {
          enabled: true
        }
      },
      sorting: {
        enabled: false
      }
    };
  }

  onRowClick (event: any): void {
    this.selectedItems = [event.row];
    this.confirm();
  }

  confirm (): void {
    this.vendorFactoryService.saveMatch(this.selectedItems[0]).then(() => {
      this.modal.close();
    }).catch(err => {
      this.messagesService.error(err);
    });
  }
}
